const CATEGORY_KEY = 'b2b-category';
const CATEGORY_TREE = 'b2b-tree-category';

export default {


  saveParams(category) {
    window.localStorage.setItem(CATEGORY_KEY, JSON.stringify(category));
  },

  loadParams() {
    let code = window.localStorage.getItem(CATEGORY_KEY);
    if (code) {
      return JSON.parse(code);
    }
    return false;
  },

  saveTree(tree) {
    let data = {
      expire: new Date().getTime(),
      category: tree
    };
    window.localStorage.setItem(CATEGORY_TREE, JSON.stringify(data));
  },

  loadTree() {
    let tree = window.localStorage.getItem(CATEGORY_TREE);
    if (tree) {
      let result = JSON.parse(tree);
      if(this.compareTime(result.expire)) {
        return result.category;
      }
    }
    return false;
  },

  compareTime(time) {
    let now = new Date().getTime();
    let diff = now - time;
    return diff < 3600000;
  },




  clear() {
    window.localStorage.removeItem(CATEGORY_KEY);
  }
}



// WEBPACK FOOTER //
// ./src/components/categories/src/CategoriesStorage.js